/* global $:false */

export default class SearchObservers {
  static init () {
    return this.remove()
  }

  static remove () {
    this.el = $('[data-remove-search-observer]')
    if (!(this.el.length > 0)) { return }

    this.el.on('click', function (event) {
      this.link = $(this)
      $.ajax({
        url: this.link.data('url'),
        data: { _method: 'delete' },
        type: 'post',
        success: data => {
          this.link.closest('[data-search-observer]').hide('fast')
        }
      })
    })
  }
}
